import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  '@keyframes enter': {
    from: { opacity: 0, transform: 'translateY(4px)' }
  },
  '@keyframes fadeIn': {
    from: { opacity: 0 }
  },
  result: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    marginTop: theme.spacing(4),
    padding: theme.spacing(3, 4),
    borderLeft: '4px solid',
    borderRadius: theme.sizes.roundCorners,
    backgroundColor: theme.colorPalette.green_100,
    color: theme.colors.light_text,
    fontSize: 14,
    lineHeight: 1.4
  },
  // Confirmed outcomes ease in; problems appear plainly. Reduced motion keeps only the fade.
  enter: {
    animation: '$enter 200ms cubic-bezier(0.23, 1, 0.32, 1)',
    '@media (prefers-reduced-motion: reduce)': {
      animationName: '$fadeIn'
    }
  },
  succeeded: {
    borderLeftColor: theme.colors.success,
    '& $icon': { color: theme.colors.success }
  },
  pending: {
    borderLeftColor: theme.colorPalette.orange_50,
    '& $icon': { color: theme.colorPalette.orange_50 }
  },
  failed: {
    borderLeftColor: theme.colors.error,
    '& $icon': { color: theme.colors.error }
  },
  icon: {
    flexShrink: 0,
    fontSize: 20
  },
  title: {
    display: 'block',
    fontWeight: 600
  },
  detail: {
    display: 'block'
  }
}));
